import { Fragment, useEffect } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import config from '@config';
import PageHeader from '@components/PageHeader/PageHeader';
const AnswerSurvey = () => {
    useEffect(() => {
        document.title = '查看答卷-医调研';
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    const goBack = () => {
        navigate('/wj/surveys/new/whitelists', { state: location.state });
    };

    return (
        <Fragment>
            <PageHeader breadcrumb={[]}>
                <div className="page-left">
                    <div className="back">
                        <i className="bi bi-chevron-left"></i>
                    </div>
                    <span>退出查看</span>
                </div>
                <div className="page-center"></div>
            </PageHeader>
            <iframe className="iframe-width" src={`${config.SURVEY_DOMAIN}/s/${location.state.surveyId}/anwsersheets/${location.state.answerId}`} />
        </Fragment>
    );
};

export default AnswerSurvey;
